import { BlogPost } from '@/types/blog';
import { content } from './content';
import mythosPositivesDenkenImage from '@/assets/blog/mythos-positives-denken-hero.webp';

export const mythosPositivesDenkenPost: BlogPost = {
  title: 'Schluss mit dem Lächeln: Warum positives Denken dein Betriebssystem sabotiert und was wirklich funktioniert',
  metaTitle: 'Toxische Positivität: Was wirklich funktioniert',
  excerpt: 'Schluss mit toxischer Positivität. Erfahre, warum radikale Akzeptanz der Schlüssel zu echter Stabilität ist und positives Denken dich blockiert.',
  date: '12.10.2025',
  slug: 'mythos-positives-denken',
  imageUrl: mythosPositivesDenkenImage,
  category: 'Mindset',
  tags: ['Mindset', 'Betriebssystem', 'Coaching', 'Psychologie', 'Toxische Positivität', 'Radikale Akzeptanz', 'Persönlichkeitsentwicklung'],
  author: 'Jörg Hörmann',
  authorTitle: 'Finanz- & Executive Coach',
  content: content,
  metaDescription: 'Schluss mit toxischer Positivität. Erfahre, warum radikale Akzeptanz der Schlüssel zu echter Stabilität ist und positives Denken dich blockiert.'
};
